// アコーディオン: [data-mp-accordion] > button[aria-expanded][aria-controls] + パネル
// 開閉は aria-expanded / aria-hidden の切替のみ。高さの変化は CSS（grid-template-rows）が担う。
// measurement.js は button の data-track-* と aria-expanded を読むので、属性はここで確実に更新する。

export function setupAccordions() {
  document.querySelectorAll('[data-mp-accordion]').forEach((root) => {
    const button = root.querySelector('button[aria-controls]');
    const panel = button && document.getElementById(button.getAttribute('aria-controls'));
    if (!button || !panel) return;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      panel.setAttribute('aria-hidden', String(!open));
    });
  });
}
